import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';
import { queryClient } from '../../queryClient';

interface TransitProps {
  id: string;
}

export const useGenerateTransitFollowLetter = () => {
  return useMutation({
    mutationFn: async ({ id }: TransitProps) => {
      const result = await apiClient.transit.generateNctsFollowLetter.mutation({ body: { transitId: id } });
      if (result.status !== 200) throw result.body;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['getUserReports'] });
      toast.success('The report is being generated.');
    },
    onError: (error) => {
      showErrorToast(error, 'Error generating the report!');
    },
  });
};
